export default "__VITE_ASSET__DE5B2avg__"